import { registerPlugin } from '@capacitor/core';
const ZephyrDfu = registerPlugin('ZephyrDfu', {
    web: () => import('./web').then(m => new m.ZephyrDfuWeb()),
});
export * from './definitions';
export { ZephyrDfu };
//# sourceMappingURL=index.js.map